import { render, staticRenderFns } from "./WrittenAnswerComponent.vue?vue&type=template&id=4e32e0d8&"
import script from "./WrittenAnswerComponent.vue?vue&type=script&lang=js&"
export * from "./WrittenAnswerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WrittenAnswerComponent.vue"
export default component.exports